import { Component, Inject, DOCUMENT } from '@angular/core';


@Component({
    selector: 'app-robots',
    templateUrl: './robots.component.html',
    styleUrls: ['./robots.component.scss'],
    standalone: false
})
export class RobotsComponent {
  hosturl:any;
  constructor( ) {

  }
  ngOnInit(){
    this.hosturl =window.location.hostname;

  }
  

}
